import _toConsumableArray from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { messageList, deleteMessage as _deleteMessage, readMessage } from '@/services/http';
import { dateTimeFormatter } from '@/tools/tools';
import NavMenu from '@/common/navmenu.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // state
    _this.messageType = '1';
    _this.isloading = false;
    _this.isEdit = false;
    _this.messageList = [];
    // 发货通知数量
    _this.deliverNumber = 0;
    // 商城消息数量
    _this.mallNumber = 0;
    _this.isAll = false;
    _this.isHasText = false;
    // 当前页数
    _this.currentpage = 1;
    // 总条数
    _this.totalnumber = 20;
    _this.pageNo = 1;
    _this.pageSize = 10;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getMessageList();
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.messageList = [];
      this.getMessageList();
    }
    // 取消选择
  }, {
    key: "cancelChoose",
    value: function cancelChoose() {
      this.isEdit = false;
    }
    // 编辑消息
  }, {
    key: "editMessage",
    value: function editMessage() {
      this.isEdit = true;
    }
    //  删除消息
  }, {
    key: "deleteMessage",
    value: function () {
      var _deleteMessage2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var arr, ids, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              arr = this.messageList.filter(function (value) {
                return value.checked && value.id;
              });
              if (!(arr.length === 0)) {
                _context.next = 5;
                break;
              }
              this.$message.error('请先勾选消息');
              _context.next = 10;
              break;
            case 5:
              ids = arr.map(function (value) {
                return value.id;
              }).join(',');
              _context.next = 8;
              return _deleteMessage({
                messageType: this.messageType,
                messageIds: ids
              });
            case 8:
              res = _context.sent;
              if (res.data.code === 100) {
                this.isEdit = false;
                this.messageList = [];
                this.getMessageList();
                this.$message.success('删除成功');
              } else {
                this.$message.error(res.data.message);
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function deleteMessage() {
        return _deleteMessage2.apply(this, arguments);
      }
      return deleteMessage;
    }() //  async getMessageSimple() {
    //    const res: any = await messageSimple();
    //    this.deliverNumber = res.data.data.sendGoodsMsgNum;
    //    this.mallNumber = res.data.data.optGoodsMsgNum;
    //  }
  }, {
    key: "getMessageList",
    value: function () {
      var _getMessageList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this2 = this;
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return messageList({
                messageType: this.messageType,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                companyId: 1
              });
            case 2:
              res = _context2.sent;
              res.data.data.list.forEach(function (ele) {
                _this2.$set(ele, 'checked', false);
              });
              this.messageList = [].concat(_toConsumableArray(this.messageList), _toConsumableArray(res.data.data.list));
              this.isHasText = this.messageList.length !== 0;
              this.totalnumber = res.data.data.total;
              this.messageSimple();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getMessageList() {
        return _getMessageList.apply(this, arguments);
      }
      return getMessageList;
    }()
  }, {
    key: "handleSelect",
    value: function handleSelect(index) {
      this.messageList[index].checked = !this.messageList[index].checked;
      this.isAll = this.messageList.every(function (e) {
        return e.checked;
      });
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(val) {
      this.messageList = [];
      this.pageSize = val;
      this.getMessageList();
    }
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(pageNo) {
      this.messageList = [];
      this.pageNo = pageNo;
      this.getMessageList();
      window.scrollTo(0, 0);
    }
    // 全选
  }, {
    key: "handleAllSelect",
    value: function handleAllSelect() {
      var _this3 = this;
      this.isAll = !this.isAll;
      this.messageList.forEach(function (ele) {
        _this3.$set(ele, 'checked', _this3.isAll);
      });
    }
    // 未读消息
  }, {
    key: "goDetails",
    value: function goDetails(serverId, id, index) {
      readMessage({
        messageType: this.messageType,
        messageId: id
      });
      if (index === 0) {
        this.$router.push("/order-details?id=".concat(serverId));
      } else {
        this.$router.push("/details?id=".concat(serverId));
      }
    }
  }]);
}(Vue);
__decorate([State('notifys')], default_1.prototype, "notifysState", void 0);
__decorate([Action('notifys/messageSimple')], default_1.prototype, "messageSimple", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    NavMenu: NavMenu,
    Footer: Footer
  },
  filters: {
    dateTime: function dateTime(value) {
      return dateTimeFormatter(value);
    }
  }
})], default_1);
export default default_1;